import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import * as moment from "moment";
import {ConciliacionService} from "../../core/conciliacion/conciliacion.service";
import { CONCILIACION_ITEM_TYPE } from './conciliacion-chart-item.component';

@Component({
  selector: 'app-conciliacion-chart',
  templateUrl: './conciliacion-chart.component.html',
  styleUrls: ['./conciliacion-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConciliacionChartComponent implements OnInit, AfterViewInit {

  private fecha = "";
  longDate = "";

  ventas = {
    type: CONCILIACION_ITEM_TYPE.CURRENCY,
    error: false,
    errorMessage: '',
    left: {
      amount: 0,
      counter: undefined
    },
    right: {
      amount: 0,
      counter: undefined
    }
  };

  cancelaciones = {
    type: CONCILIACION_ITEM_TYPE.CURRENCY,
    error: false,
    errorMessage: '',
    left: {
      amount: 0,
      counter: undefined
    },
    right: {
      amount: 0,
      counter: undefined
    }
  };

  apuestas = {
    type: CONCILIACION_ITEM_TYPE.COUNTER,
    left: {
      amount: undefined,
      counter: 0
    },
    right: {
      amount: undefined,
      counter: 0
    }
  };

  apuestasError = {
    type: CONCILIACION_ITEM_TYPE.NONE,
    error: false,
    errorMessage: '',
    hideDiff: true,
    left: {
      caption: 'Total de Apuestas',
      affinity: 'counter',
      amount: undefined,
      counter: 0
    },
    right: {
      caption: 'Monto',
      affinity: 'amount',
      amount: 0,
      counter: undefined
    }
  };

  rangeDates: Date[] = [];
  maxDateValue;
  defaultDate;
  fechaSimple: Date;

  constructor(private conciliacionService: ConciliacionService) {
  }

  ngOnInit() {
    const today = moment().subtract(1, 'days').toDate();
    this.rangeDates[0] = today;
    this.rangeDates[1] = today;
    this.maxDateValue = today;
    this.defaultDate = today;
    this.fechaSimple = today;
    this.fecha = moment(today).format("YYYY-MM-DD");
    this.longDate = moment(today).locale('es').format("DD [de] MMMM YYYY");
  }

  ngAfterViewInit(): void {
    this.updateData([this.fechaSimple, this.fechaSimple]);
  }

  updateData(rangeDates: Date[]): void  {

    const startDate = moment(rangeDates[0]).format("YYYY-MM-DD");
    const endDate = moment(rangeDates[1]).format("YYYY-MM-DD");

    this.ventas.error = false;
    this.apuestasError.error = false;
    this.cancelaciones.error = false;

    this.conciliacionService.getDashboardData(startDate, endDate)
      .subscribe((data) => {
        if (data) {
          this.ventas.left.amount = data.montoGlotto;
          this.ventas.right.amount = data.montoPpap;

          this.apuestas.left.counter = data.totalVentasGlotto;
          this.apuestas.right.counter = data.totalVentasPpap;
          this.apuestas = Object.assign({}, this.apuestas);
        }
      }, error => {
        this.ventas.error = true;
        this.ventas.errorMessage = `Ventas - ${error}`;
      });

    this.conciliacionService.getDashboardErrorData(startDate, endDate)
      .subscribe((data) => {
        if (data) {
          this.apuestasError.left.amount = undefined;
          this.apuestasError.left.counter = data.totalVentasGlotto;

          this.apuestasError.right.amount = data.montoGlotto;
          this.apuestasError.right.counter = undefined;

          this.apuestasError = Object.assign({}, this.apuestasError);
        }
      }, error => {
        this.apuestasError.error = true;
        this.apuestasError.errorMessage = `Apuestas con Error - ${error}`;
      });

    this.conciliacionService.getDashboarCancelacionesdData(startDate, endDate)
      .subscribe((data) => {
        if (data) {
          this.cancelaciones.left.amount = data.montoGlotto;
          this.cancelaciones.right.amount = data.montoPpap;
          this.cancelaciones = Object.assign({}, this.cancelaciones);
        }
      }, error => {
        this.cancelaciones.error = true;
        this.cancelaciones.errorMessage = `Cancelaciones - ${error}`;
      });

  }

  getForDate() {
    this.updateData([this.rangeDates[0], this.getFinalDate()]);
  }

  private getFinalDate() {
    if (this.rangeDates[1]) {
      return this.rangeDates[1];
    } else {
      return this.rangeDates[0];
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/conciliacion/conciliacion-chart.component.ts